import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type ApiKeyData, type ApiKeyCreateResult } from '../api/client';

const API_KEYS_KEY = ['apiKeys'] as const;

export function useApiKeys() {
  return useQuery<ApiKeyData[]>({
    queryKey: API_KEYS_KEY,
    queryFn: () => api.apiKeys.list(),
  });
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();

  return useMutation<ApiKeyCreateResult, Error, { name: string; permissions: string[] }>({
    mutationFn: (data) => api.apiKeys.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: API_KEYS_KEY });
    },
  });
}

export function useRevokeApiKey() {
  const queryClient = useQueryClient();

  return useMutation<{ message: string }, Error, string>({
    mutationFn: (keyId) => api.apiKeys.revoke(keyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: API_KEYS_KEY });
    },
  });
}
